// ============================================
// SSVENT WEBSITE - MASTER CONTENT FILE
// ============================================
// 
// HOW TO EDIT THIS FILE:
// 1. Open this file in any text editor (Notepad, VS Code, etc.)
// 2. Find the section you want to edit
// 3. Change the text between the quotes "..."
// 4. Save the file
// 5. Rebuild the website (see PDF guide)
//
// IMPORTANT: 
// - Don't remove the quotes around text
// - Don't change the variable names (left side of :)
// - Only change the values (right side of :)
// ============================================

// ============================================
// SECTION 1: COMPANY INFORMATION
// ============================================
export const COMPANY = {
  name: "Shree Siddhivinayak Enterprise",
  shortName: "SSVent",
  tagline: "Your Trusted Partner in Scientific & Laboratory Solutions",
  description: "Shree Siddhivinayak Enterprise is recognized as a reliable and reputable vendor for pharmaceutical, food, specialty chemicals, API manufacturing industries, and research institutes across India.",
  established: "2010",
  yearsInBusiness: "16+",
  teamSize: "50+",
  locations: "3",
  
  // Contact Information
  email: "infoahd@ssvent.com",
  phone: "+91 7575008857",
  
  // WhatsApp Settings
  whatsappNumber: "917575008857",
  whatsappMessage: "Hi, I'm interested in your lab equipment and would like to know more about your products and services.",
  
  // Logo URL
  logo: "https://www.ssvent.com/wp-content/uploads/elementor/thumbs/siddhi-logo-01-1-pe7v45zpzvqko4zmlvhy2sc9x1ucmrg0hrmznmev8i.png",
  
  // Social Media Links (add your links here)
  socialMedia: {
    facebook: "",
    linkedin: "https://www.linkedin.com/company/shree-siddhivinayak-enterprise/?viewAsMember=true",
    twitter: "",
    instagram: ""
  }
};

// ============================================
// SECTION 2: NAVIGATION MENU
// ============================================
export const NAVIGATION = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  { name: "Products", path: "/products" },
  { name: "Achievements", path: "/achievements" },
  { name: "Downloads", path: "/downloads" },
  { name: "Contact", path: "/contact" }
];

// ============================================
// SECTION 3: HOME PAGE CONTENT
// ============================================
export const HOME_PAGE = {
  hero: {
    overline: "Laboratory Solutions Partner",
    title: "Your Trusted Partner in Scientific & Laboratory Solutions",
    description: "Shree Siddhivinayak Enterprise is recognized as a reliable and reputable vendor for pharmaceutical, food, specialty chemicals, API manufacturing industries, and research institutes across India.",
    primaryButton: "Request Quote",
    secondaryButton: "Explore Products",
    image: "https://images.unsplash.com/photo-1771678040857-51d00a11be7a?crop=entropy&cs=srgb&fm=jpg"
  },
  
  verticals: [
    "Analytical & Chromatography",
    "Microbiology",
    "Biotechnology"
  ],
  
  stats: [
    { number: "16+", label: "Years in Business" },
    { number: "50+", label: "Team Members" },
    { number: "3", label: "Locations in Gujarat" },
    { number: "2010", label: "Established" }
  ]
};

// ============================================
// SECTION 4: ABOUT US PAGE CONTENT
// ============================================
export const ABOUT_PAGE = {
  hero: {
    title: "About Shree Siddhivinayak Enterprise",
    subtitle: "Precision, Performance, Partnership."
  },
  
  whoWeAre: {
    title: "Who We Are",
    paragraphs: [
      "It is a matter of pride to highlight the journey of Shree Siddhivinayak Enterprise (SSE) and its growing contribution to India's laboratory equipment and scientific supplies sector. Established with a clear vision of delivering quality-driven and reliable solutions, SSE has steadily built a reputation for professionalism and customer-centric service.",
      "The foundation of SSE is strongly supported by its founders, Mr. Vijay Trivedi and Mr. Manish Dave, whose combined expertise in sales, marketing, finance, and business management has been instrumental in shaping the organization's growth.",
      "Under their guidance, SSE continues to focus on operational excellence, long-term client relationships, and delivering value through quality products and dependable service support."
    ]
  },
  
  commitment: {
    title: "Our Commitment to Quality",
    content: "We are a trusted supplier and solution partner for pharmaceutical and laboratory instruments, providing reliable equipment designed to support GMP-compliant environments. Our expertise lies in understanding critical industry requirements and delivering solutions that ensure accuracy, consistency, and operational excellence."
  },
  
  coreValues: [
    {
      title: "Transparency",
      description: "We practice openness and clarity in all our dealings. From product specifications and pricing to delivery commitments and service support, we ensure complete transparency."
    },
    {
      title: "Honesty",
      description: "Honesty forms the cornerstone of our business relationships. We communicate realistically, set clear expectations, and consistently deliver on our commitments."
    },
    {
      title: "Quality of Service",
      description: "Quality for us goes beyond products — it extends to the entire customer experience. We strive to understand our clients' operational requirements, regulatory expectations, and timelines."
    },
    {
      title: "People-Centric Approach",
      description: "We believe that strong organizations are built by strong teams and meaningful relationships. We prioritize understanding our customers' challenges and becoming dependable solution partners."
    },
    {
      title: "Integrity",
      description: "Integrity is the guiding principle behind every decision we make. We uphold ethical standards, fairness, and responsibility in all circumstances."
    }
  ],
  
  journey: [
    {
      year: "2010",
      title: "Foundation",
      description: "Shree Siddhivinayak Enterprise began its journey under the visionary leadership of Mr. Vijay Trivedi and Mr. Manish Dave, whose combined expertise laid the strong foundation."
    },
    {
      year: "2014",
      title: "Ankleshwar Expansion",
      description: "Established Ankleshwar branch office under the leadership of Mr. Darshan Mehta, enhancing our ability to serve key industrial and pharmaceutical clients."
    },
    {
      year: "2017",
      title: "Vadodara Office",
      description: "Branch office at Vadodara started with Mr. Ravichandra Patel as Partner, focusing on Microbiological products with 25+ years of experience."
    },
    {
      year: "2017",
      title: "Phoenix Launch",
      description: "M/s Phoenix started with allied product range of FILTERS with Mr. Sudhirsinh Chauhan, having 30+ years of experience in domestic and international markets."
    },
    {
      year: "2018",
      title: "Service Company",
      description: "Established a service company specializing in comprehensive instrument maintenance, including AMC, CMC, calibration, and breakdown support."
    },
    {
      year: "2019",
      title: "MICROBIOME Launch",
      description: "Launched our own brand 'MICROBIOME' - a world of all kind of consumables required for Microbiology Lab."
    },
    {
      year: "2024",
      title: "SUPERCHROM Launch",
      description: "Launched another brand 'SUPERCHROM' - diverse consumables essential for Chrome Consumables in the Analytical Lab."
    },
    {
      year: "2025",
      title: "₹50 Crore Milestone",
      description: "SSE has successfully achieved a turnover exceeding ₹50 Crore and is strategically progressing toward ₹100 Crore by 2030."
    }
  ],
  
  founders: [
    {
      name: "Mr. Vijay Trivedi",
      role: "Co-Founder",
      expertise: "Sales, Marketing & Business Strategy"
    },
    {
      name: "Mr. Manish Dave",
      role: "Co-Founder",
      expertise: "Finance & Business Management"
    },
    {
      name: "Mr. Darshan Mehta",
      role: "Partner",
      expertise: "Sales, Marketing & Business Strategy for South Gujarat"
    },
    {
      name: "Mr. Ravi Patel",
      role: "Partner",
      expertise: "Finance & Business Management for Central Gujarat"
    },
    {
      name: "Mr. Dheyay Patel",
      role: "Partner",
      expertise: "Sales, Marketing & Business Strategy for Central Gujarat"
    }

  ],
  
  teamSection: {
    title: "Our Team",
    description: "Our dedicated team of 50+ professionals brings together decades of experience in laboratory solutions, technical support, and customer service.",
    teamPageUrl: "https://www.ssvent.com/team/",
    image: "https://cdn.pixabay.com/photo/2023/10/27/06/02/clinical-trial-consulting-8344100_1280.jpg"
  }
};

// ============================================
// SECTION 5: PRODUCTS PAGE CONTENT
// ============================================
// 
// HOW TO ADD LINKS TO PRODUCTS:
// Each product can have a "url" field for linking to a page or datasheet
// Example: { name: "Product Name", url: "https://link-to-page-or-datasheet" }
// If no url is provided, the product will just display as text
//
export const PRODUCTS_PAGE = {
  hero: {
    title: "Our Products",
    subtitle: "Comprehensive Laboratory Solutions from World-Leading Brands"
  },
  
  categories: [
    {
      id: "lab-instruments",
      name: "Lab Instruments",
      description: "Comprehensive range of analytical, chromatography, and scientific instruments from leading global brands.",
      image: "https://www.ssvent.com/wp-content/uploads/2022/03/pexels-photo-3825368-1-1.jpeg",
      subcategories: [
        {
          name: "Analytical Instruments",
          products: [
            { name: "OHAUS Weighing Solution", url: "https://asiapacific.ohaus.com/en-ap/sections/lab-balances" },
            { name: "OHAUS Moisture Analyzer", url: "https://asiapacific.ohaus.com/en-ap/products/balances-scales/moisture-analyzers" },
	    { name: "OHAUS Industrial Scales", url: "https://asiapacific.ohaus.com/en-ap/sections/industrial-scales" },
            { name: "HORIBA pH/Conductivity/DO/Ion Bench Meters", url: "https://www.horiba.com/int/water-quality/bench-meters/" },
            { name: "HORIBA pH/Conductivity/DO/Ion Handheld Meters", url: "https://www.horiba.com/int/water-quality/handheld-meters/" },
            { name: "HORIBA pH/Conductivity/DO/Ion Pocket Meters", url: "https://www.horiba.com/int/water-quality/pocket-meters/" },
	    { name: "HORIBA Electrodes and Other Accessories", url: "https://www.horiba.com/int/water-quality/electrodes/" },
            { name: "ELGA Lab Water Purification System", url: "https://www.elgalabwater.com/" }
          ]
        },
        {
          name: "General Laboratory Instruments",
          products: [
            { name: "Centrifuge", url: "https://asiapacific.ohaus.com/en-ap/products/equipment/centrifuges" },
            { name: "Open Air Shaker", url: "https://asiapacific.ohaus.com/en-ap/products/equipment/open-air-shakers" },
            { name: "Lab Vortex Mixer", url: "https://asiapacific.ohaus.com/en-ap/products/equipment/laboratory-vortex-mixers" },
            { name: "Dry block Heaters", url: "https://asiapacific.ohaus.com/en-ap/products/equipment/dry-block-heaters" },
            { name: "Hotplates & Stirrer", url: "https://asiapacific.ohaus.com/en-ap/products/equipment/hotplates-stirrers" },
            { name: "Overhead Stirrer", url: "https://asiapacific.ohaus.com/en-ap/products/equipment/overhead-stirrers" },
            { name: "Incubating Cooling Shakers", url: "https://asiapacific.ohaus.com/en-ap/products/equipment/incubating-incubating-cooling-shakers" }
          ]
        },
        {
          name: "Microbiology Lab Instruments",
          products: [
            { name: "Equitron Autoclave", url: "https://www.medicainstrument.com/autoclave.php" },
            { name: "Equitron Oven/Incubator", url: "https://www.medicainstrument.com/oven-inc.php" },
            { name: "Equitron Steam Pot", url: "https://www.medicainstrument.com/bath/Steam-Pot-Media-Digestion.php" },
            { name: "Equitron Colony Counter", url: "https://www.medicainstrument.com/QC-Micro/Colony-Counter.php" },
            { name: "Equitron Bio Safety", url: "https://www.medicainstrument.com/biosafety-cabinet.php" },
            { name: "Equitron Glassware Washer", url: "https://www.medicainstrument.com/washer.php" },
            { name: "Water bath", url: "https://www.medicainstrument.com/bath.php" },
            { name: "Microbiology Accessories", url: "https://www.medicainstrument.com/sundry-items.php" },
          ]
        }
      ]
    },
    {
      id: "lab-consumables",
      name: "Lab Consumables",
      description: "Quality consumables for pharmaceutical, research, and industrial laboratories. Complete fulfillment solutions.",
      image: "https://www.ssvent.com/wp-content/uploads/2022/03/pexels-photo-954583-1.jpeg",
      subcategories: [
        {
          name: "Analytical & Chrome Consumables",
          products: [
            { name: "Perkin Elmer Consumables", url: "" },
            { name: "Sartorius Analytical & Chrome Consumables", url: "" }
          ]
        },
        {
          name: "General Laboratory Consumables",
          products: [
            { name: "Sartorius General Laboratory Consumables", url: "" },
            { name: "Glassco Glasswares & MISC Consumables", url: "" }
          ]
        },
        {
          name: "Microbiology Lab Consumables",
          products: [
            { name: "Sartorius Microbiology Lab Consumables", url: "" },
            { name: "Microbiome Products", url: "" }
          ]
        }
      ]
    }
  ]
};

// ============================================
// SECTION 6: ACHIEVEMENTS PAGE CONTENT
// ============================================
export const ACHIEVEMENTS_PAGE = {
  hero: {
    title: "Our Achievements",
    subtitle: "Recognition of Our Commitment to Excellence"
  },
  
  awards: [
    {
      year: "2020",
      title: "No.1 Distributor",
      description: "For the sales of Chromatography & Analytical Consumables for Perkin Elmer",
      brand: "Perkin Elmer"
    },
    {
      year: "2020",
      title: "Best Performer",
      description: "Liquid handling sales for year 2020",
      brand: "Sartorius"
    },
    {
      year: "2019",
      title: "Performance Award",
      description: "For outstanding contribution in the promotion & Sale in the year 2018",
      brand: "Sartorius"
    },
    {
      year: "2018-19",
      title: "Best Performer",
      description: "Perkin Elmer Analytical & Chrom Consumables",
      brand: "Perkin Elmer"
    },
    {
      year: "2018-19",
      title: "Excellence Award",
      description: "For excellence from GLASSCO, Sartorius Liquid handling business",
      brand: "Glassco & Sartorius"
    },
    {
      year: "2017-18",
      title: "Exceptional Achievement",
      description: "From GLASSCO, Perkin Elmer, Sartorius Liquid handling business",
      brand: "Multiple Brands"
    },
    {
      year: "2016-17",
      title: "Best Channel Partner",
      description: "Recognition for being the best channel partner",
      brand: "Glassco"
    },
    {
      year: "2016-17",
      title: "Certificate of Appreciation",
      description: "For Commitment, Dedication and Performance",
      brand: "Glassco"
    },
    {
      year: "2016-17",
      title: "Best Distributor",
      description: "Best distributor award for the year",
      brand: "Equitron Medica"
    }
  ],
  
  achievementImage: "https://www.ssvent.com/wp-content/uploads/2022/03/Untitled-design-2021-12-17T164438.091.png"
};

// ============================================
// SECTION 7: DOWNLOADS PAGE CONTENT
// ============================================
export const DOWNLOADS_PAGE = {
  hero: {
    title: "Downloads",
    subtitle: "Product Brochures, Catalogs & Technical Documents"
  },
  
  // Add your downloadable files here
  // Format: { name: "File Name", description: "Description", url: "download link", category: "Category" }
  files: [
    {
      name: "Glassco Glasswares Catalog",
      description: "Complete catalog of Glassco glasswares and MISC products",
      url: "https://drive.google.com/file/d/17fPSai54VzOdMdkohMagVu_5xb9p---F/view",
      category: "Catalogs",
      fileType: "PDF"
    },
    {
      name: "Metrohm Product Brochure",
      description: "Metrohm analytical instruments brochure",
      url: "https://drive.google.com/file/d/1rEvuJdwYlfl1prGyyV1RY1LSAmtp-euY/view",
      category: "Brochures",
      fileType: "PDF"
    }
    // Add more files as needed:
    // {
    //   name: "Your File Name",
    //   description: "Description of the file",
    //   url: "https://link-to-your-file.pdf",
    //   category: "Catalogs", // or "Brochures", "Technical Docs", etc.
    //   fileType: "PDF"
    // }
  ],
  
  categories: ["All", "Catalogs", "Brochures", "Technical Docs", "Certificates"]
};

// ============================================
// SECTION 8: CONTACT PAGE CONTENT
// ============================================
export const CONTACT_PAGE = {
  hero: {
    title: "Contact Us",
    subtitle: "We'd Love to Hear From You"
  },
  
  form: {
    title: "Send Us a Message",
    description: "Fill out the form below and our team will get back to you within 24 hours.",
    submitButton: "Send Message"
  },
  
  offices: [
    {
      name: "Head Office - Ahmedabad",
      address: "1006-1007, Shilp Epitome, Behind Rajpath Club, Rajpath Rangoli Road, Bodakdev, Ahmedabad 380054, Gujarat, India.",
      phone: "+91 7575008857",
      email: "infoahd@ssvent.com",
      mapUrl: "https://maps.app.goo.gl/NEon8gyT6Hv9d1466"
    },
    {
      name: "Warehouse",
      address: "8, J.P Estate, B/H Sagar Hotel, Nr Sanand cross Rd, Sarkhej Gandhinagar Road, Sarkhej, Ahmedabad, 382210, Gujarat, India.",
      phone: "+91 9081810112",
      email: "infoahd@ssvent.com",
      mapUrl: "https://maps.app.goo.gl/TPEZWv1nBxbofRcT7"
    },
    {
      name: "Ankleshwar Office",
      address: "Office No. GF-57/58, Real Residency, Near Jaldhara Chokdi, G.I.D.C, Ankleshwar, 393002 Dist. Bharuch, Gujarat, India.",
      phone: "+91 9998295254",
      email: "infoahd@ssvent.com",
      mapUrl: "https://g.co/kgs/5ckH4u7"
    },
    {
      name: "Vadodara Office",
      address: "7-A, Rutu Villa Bungalow, Opp. Somnath Nagar Shopping Center, Nr. Ravi Park Char Rasta, Tarsali, Vadodara - 390009, Gujarat, India.",
      phone: "+91 7575008853",
      email: "infoahd@ssvent.com",
      mapUrl: "https://maps.app.goo.gl/ubcdGgwEaJnGAsoa7"
    }
  ]
};

// ============================================
// SECTION 9: BRAND PARTNERS
// ============================================
export const BRAND_PARTNERS = [
  { name: "YMC", logo: "https://www.ssvent.com/wp-content/uploads/2024/07/images.jpg", url: "https://www.ymcindia.com/" },
  { name: "Buchi", logo: "https://www.ssvent.com/wp-content/uploads/2024/07/images.png", url: "https://www.buchi.com/" },
  { name: "Masterflex", logo: "https://www.ssvent.com/wp-content/uploads/2024/07/masterflex.png", url: "https://in.vwr.com/cms/masterflex-peristaltic-tubing-pump-systems" },
  { name: "Peak Scientific", logo: "https://www.ssvent.com/wp-content/uploads/2024/07/7-e1721048609820.png", url: "https://www.peakscientific.com/" },
  { name: "PerkinElmer", logo: "https://www.ssvent.com/wp-content/uploads/2022/05/Untitled-design-2022-05-23T163201.721-e1721048700382.png", url: "https://www.perkinelmer.com/" },
  { name: "Bio-Rad", logo: "https://www.ssvent.com/wp-content/uploads/2022/05/Untitled-design-2022-05-23T163455.660.png", url: "https://www.bio-rad.com/" },
  { name: "Thermo Fisher Scientific", logo: "https://www.ssvent.com/wp-content/uploads/2022/05/Untitled-design-2022-05-23T163621.699.png", url: "https://www.thermofisher.com/" },
  { name: "Equitron Medica", logo: "https://www.ssvent.com/wp-content/uploads/2022/05/Untitled-design-2022-05-23T164805.721.png", url: "https://www.medicainstrument.com/" },
  { name: "Nikon", logo: "https://www.ssvent.com/wp-content/uploads/2022/05/Untitled-design-2022-05-23T164100.526.png", url: "https://www.nikon.com/" },
  { name: "HORIBA Scientific", logo: "https://www.ssvent.com/wp-content/uploads/2022/05/Untitled-design-2022-05-23T164240.800.png", url: "https://www.horiba.com/" },
  { name: "Ohaus", logo: "https://www.ssvent.com/wp-content/uploads/2022/05/Untitled-design-2022-05-23T164519.746.png", url: "https://asiapacific.ohaus.com/" },
  { name: "Sartorius", logo: "https://www.ssvent.com/wp-content/uploads/2022/05/Untitled-design-2022-05-23T165228.695.png", url: "https://www.sartorius.com/" },
  { name: "Glassco", logo: "https://www.ssvent.com/wp-content/uploads/2022/05/Untitled-design-2022-05-23T165316.185.png", url: "https://glasscolabs.in/" },
  { name: "Fujifilm Wako", logo: "https://www.ssvent.com/wp-content/uploads/2022/05/Untitled-design-2022-05-23T165525.738.png", url: "https://labchem-wako.fujifilm.com/" },
  { name: "Avantor", logo: "https://www.ssvent.com/wp-content/uploads/2022/05/Untitled-design-2022-05-23T165646.735.png", url: "https://www.avantorsciences.com/" },
  { name: "Metrohm", logo: "https://www.ssvent.com/wp-content/uploads/2022/05/Untitled-design-2022-05-23T165829.739.png", url: "https://www.metrohm.com/" },
  { name: "Telesis Bio", logo: "https://www.ssvent.com/wp-content/uploads/2024/07/images-2.png", url: "https://telesisbio.com/" }
];

// ============================================
// SECTION 10: FOOTER CONTENT
// ============================================
export const FOOTER = {
  description: "Your trusted partner in scientific and laboratory solutions since 2010. Serving pharmaceutical, research, and industrial facilities across India.",
  copyright: "Shree Siddhivinayak Enterprise. All rights reserved.",
  
  quickLinks: [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Products", path: "/products" },
    { name: "Contact", path: "/contact" }
  ]
};
